import React, { useState } from 'react';
import './ChatBox.css';
import PropTypes from 'prop-types';

const ChatBox = ({ messages, onSendMessage }) => {
  const [message, setMessage] = useState('');

  const handleSendMessage = () => {
    if (message.trim()) {
      onSendMessage(message);
      setMessage('');
    }
  };

  return (
    <div className="chat-box">
      <h3 id="chat-box-heading">Chat</h3>
      <div className="messages" role="log" aria-live="polite">
        {messages.map((msg, index) => (
          <div key={index} className="message">
            {msg}
          </div>
        ))}
      </div>
      <input
        type="text"
        placeholder="Escreva uma mensagem..."
        aria-label="Escreva uma mensagem para o paciente"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSendMessage();
          }
        }}
      />
    </div>
  );
};

ChatBox.propTypes = {
  messages: PropTypes.array.isRequired,
  onSendMessage: PropTypes.func.isRequired,
};

export default ChatBox;
